import axios from "axios";
import { axiosConsumer } from "./axiosConsumer";

export const getAllContractRecords = async (
  page = 1,
  per_page = 200
): Promise<unknown[]> => {
  const { data } = await axiosConsumer.get(
    `api/v1/contract?page=${page}&per_page=${per_page}`
  );
  return data;
};

export const getPlans = async (
  page = 1,
  per_page = 200
): Promise<unknown[]> => {
  const { data } = await axiosConsumer.get(
    `api/v1/plan?page=${page}&per_page=${per_page}`
  );
  return data;
};

export const cancelPlan = async (planId, body): Promise<unknown[]> => {
  const { data } = await axiosConsumer.post(
    `api/v1/cancel-plan/${planId}`,
    body
  );
  return data;
};

export const cancelPlanCalculateAmount = async (planId): Promise<unknown[]> => {
  const { data } = await axiosConsumer.post(
    `api/v1/cancel-plan/${planId}/refund-amount`
  );
  return data;
};

export const searchPlans = async (
  searchData,
  page = 1,
  per_page = 200
): Promise<unknown[]> => {
  const { data } = await axiosConsumer.post(
    `api/v1/plan/search-contract?page=${page}&per_page=${per_page}`,
    searchData
  );
  return data;
};

export const getPlanById = async (id: string): Promise<unknown[]> => {
  const { data } = await axiosConsumer.get(`api/v1/plan/${id}`);
  return data;
};

export const getPendingContractRecords = async (
  page = 1,
  per_page = 200
): Promise<unknown[]> => {
  const { data } = await axiosConsumer.get(
    `api/v1/contract?page=${page}&per_page=${per_page}`
  );
  return data;
};

export const searchPendingContractRecords = async (
  searchData,
  page = 1,
  per_page = 200
): Promise<unknown[]> => {
  const { data } = await axiosConsumer.post(
    `api/v1/search-contract?page=${page}&per_page=${per_page}`,
    searchData
  );
  return data;
};

export const getPendingContractRecordsById = async (
  id: string
): Promise<unknown[]> => {
  const { data } = await axiosConsumer.get(`api/v1/contract/${id}`);
  return data;
};

export const insertContractItem = async (payload: any): Promise<unknown[]> => {
  const { data } = await axiosConsumer.post(`api/v1/contract`, payload);
  return data;
};

export const importContractItem = async (payload: any): Promise<unknown[]> => {
  const { data } = await axiosConsumer.post(`api/v1/import-contract`, payload);
  return data;
};

export const getPresignedURL = async (
  folderName: string,
  fileType: string,
  fileExtension?: string,
  dealerId?: string
): Promise<unknown[]> => {
  const queryParams = [`folderName=${folderName}`, `fileType=${fileType}`];
  if (fileExtension) queryParams.push(`fileExtension=${fileExtension}`);
  if (dealerId) queryParams.push(`dealerId=${dealerId}`);

  const { data } = await axiosConsumer.get(
    `/api/v1/file-upload-url?${queryParams.join("&")}`
  );
  return data;
};

export const sendEmail = async (payload: {
  planId: string;
  contactId: string;
  oldEmail: string;
  newEmail: string;
  phone?: string;
  oldPhone?: string;
  csr?: string;
}): Promise<any> => {
  const { data } = await axiosConsumer.post(
    "/api/v1/claim-request-file-email",
    payload
  );
  return data;
};
